import ayamGoreng from '../../public/images/menus/ayamGoreng.jpg';
import burger from '../../public/images/menus/burger.jpg';
import gadoGado from '../../public/images/menus/gadoGado.jpg';
import ikanGoreng from '../../public/images/menus/ikanGoreng.jpg';
import kentangGoreng from '../../public/images/menus/kentangGoreng.jpg';
import miGoreng from '../../public/images/menus/miGoreng.jpg';
import nasiGoreng from '../../public/images/menus/nasiGoreng.jpg';
import nasiPadang from '../../public/images/menus/nasiPadang.jpg';
import pizza from '../../public/images/menus/pizza.jpg';
import rawon from '../../public/images/menus/rawon.jpg';
import rendang from '../../public/images/menus/rendang.jpg';
import sate from '../../public/images/menus/sate.jpg';
import sotoAyam from '../../public/images/menus/sotoAyam.jpg';

const menuImages = {
  ayamGoreng,
  burger,
  gadoGado,
  ikanGoreng,
  kentangGoreng,
  miGoreng,
  nasiGoreng,
  nasiPadang,
  pizza,
  rawon,
  rendang,
  sate,
  sotoAyam,
};

export default menuImages;
